import React from "react";
import { Reveal } from "@/components/motion/Reveal";
import { Eyebrow } from "@/components/kit";

/**
 * PageHeader — reusable light header for interior pages.
 * Props: kicker, italic (line 1), bold (line 2, gradient), lede.
 */
const PageHeader = ({ kicker, italic, bold, lede }) => (
  <div className="mt-10 lg:mt-14 mb-14 lg:mb-20 max-w-4xl">
    <Reveal>
      <Eyebrow>{kicker}</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h1 className="mt-6 font-display font-black text-coal tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-7xl text-balance">
        {italic && <span className="block">{italic}</span>}
        {bold && <span className="block text-gradient-blue">{bold}</span>}
      </h1>
    </Reveal>
    {lede && (
      <Reveal delay={0.16}>
        <p className="mt-7 max-w-2xl text-lg lg:text-xl text-coal/60 leading-relaxed">{lede}</p>
      </Reveal>
    )}
  </div>
);

export default PageHeader;
